import { Currency, ETHER, Token } from '@uniswap/sdk-core'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'HYPE'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
